export const searchOptions = [
	{ value: 'name', label: 'Salesman Name' },
	{ value: 'phone', label: 'Phone Number' },
	{ value: 'isActive', label: 'Active(0/1)' }
];
